/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Hide extension button",
  "description": "Removes the \"Add Extension\" button from the block palette.",
  "tags": [
    "theme",
    "MistWarp"
  ],
  "credits": [
    {
      "name": "Mistium",
      "link": "https://mistium.com/"
    }
  ],
  "enabledByDefault": false,
  "dynamicDisable": true,
  "userstyles": [
    {
      "url": "hide-button.css"
    }
  ]
};
export default manifest;
